export const ACTIVE_TICKETS = 'ActiveTickets';
export const SOLVED_TICKETS = 'SolvedTickets';
export const ALL_TICKETS = 'AllTickets';
export const QUICK_LINKS_ACTIVE_TICKETS = 'ACTIVE TICKETS';
export const QUICK_LINKS_SOLVED_TICKETS = 'SOLVED TICKETS';
export const QUICK_LINKS_ALL_TICKETS = 'ALL TICKETS';

export const ACTIVE_TICKET_INDEX = 0;
export const SOLVED_TICKET_INDEX = 1;

export const HOLD_STATUS_LOWER_CASE = 'hold';
export const HOLD_STATUS_UPPER_CASE = 'ON-HOLD';

export const SUPPORT_TICKET_SOLVED = 'solved';
export const SUPPORT_TICKET_CLOSED = 'closed';

export const REMOVE_SELECTED_FILE_FROM_CREATE_SUPPORT_TICKET = 'This action will remove the selected file from create suport ticket form. Are you sure?';
export const REMOVE_SELECTED_FILE_FROM_FOLLOWUP_SUPPORT_TICKET = 'This action will remove the selected file. Are you sure ?';